import { regionAppConfig } from '@locales';
import { PartialRecord } from '@tsl-frontend/tsl-utilities';

import { MembershipType } from '@types';

export const errorPageContentConfig: PartialRecord<MembershipType, string[]> = {
    [MembershipType.ADMIN]: [
        'Check you are connected to the internet, and try again.',
        `If you are still having issues, please call our support team who can help resolve the issue on ${regionAppConfig.contactPhone}.`,
    ],
    [MembershipType.STUDENT]: [
        'Check you are connected to the internet, and try again.',
        'Otherwise, ask your teacher to check that your IT set up has been completed. Sometimes, the filtering on your school network blocks access to Third Space Learning.',
        `If you are still having issues, please call our support team who can help resolve the issue on ${regionAppConfig.contactPhone}.`,
    ],
    [MembershipType.TUTOR]: [
        'Check you are connected to the internet, and try again.',
        'Otherwise, check that you have no chrome extensions running, and that you are not connected to a network using a firewall or proxy that could be blocking access to Third Space Learning.',
        'If you are still having issues, please inform your team leader immediately.',
    ],
};
